// extracted by mini-css-extract-plugin
module.exports =  {"mapCanvas":"_93444fe79c--mapCanvas--RKbYL"};